import React from 'react';

import BylineWithHeadshot from '@components/BylineWithHeadshot';
import LazyImgixImage from '@components/LazyImgixImage';
import { Author } from '@interfaces/authors';
import { CompanyData } from '@interfaces/ti50';
import { project_path } from '@routes';
import { parameterize } from '@utils/formatting';
import { getImgixSrc } from '@utils/images';
import { AuthoredContentReactToHtmlParser } from '@utils/reactHtmlParserTransform';

import CompanyTable from './CompanyTable';

interface CategorySectionProps {
  authors: Author[];
  category: string;
  categoryImageName: string;
  data: CompanyData;
  description: string;
  projectSlug: string;
  TI50Year: number;
}

const CategorySection = ({
  authors,
  category,
  categoryImageName,
  data,
  description,
  projectSlug,
  TI50Year,
}: CategorySectionProps) => {
  return (
    <section id={`outer-section-${category}`} className="category-section mt-48">
      <div className="category-intro mb3" id={`section-${category}`}>
        <div className="col-xs-11">
          <LazyImgixImage
            className="h-[180px] w-[180px]"
            src={getImgixSrc({
              path: `${project_path(projectSlug)}/categories/${categoryImageName}.svg`,
              isEnvDependent: false,
            })}
          />
          <h2 className="section-title" id={parameterize(category)}>
            Top <span>{category}</span> Startups
          </h2>
          <div className="section-description mt2">
            {AuthoredContentReactToHtmlParser(description)}
          </div>
          {authors && authors.length > 0 && (
            <div className="mb-24 flex justify-center">
              <BylineWithHeadshot authors={authors} />
            </div>
          )}
        </div>
      </div>
      <div className="mobile-tap">
        <span className="mobile-word">Tap</span>
        <span className="desktop-word">Click</span> a company for more information
      </div>
      <CompanyTable
        category={category}
        companies={data[category]}
        projectSlug={projectSlug}
        TI50Year={TI50Year}
      />
    </section>
  );
};

export default CategorySection;
